import { CardProfileType } from "../../types/CardProfileType";

export type CardProfileMapType = {
    forms: {
        apac: Partial<{ [key in CardProfileType]: string }>;
        eft4f: Partial<{ [key in CardProfileType]: string }>;
    };
};

export const CardProfileFormConfigMap: CardProfileMapType = {
    forms: {
        apac: {
            [CardProfileType.BANK_CARD]: "card-profile-apac-bank-card",
            [CardProfileType.EBT_CARD]: "card-profile-apac-ebt-card",
            [CardProfileType.GIFT_CARD]: "card-profile-apac-gift-card",
            [CardProfileType.PETROL_CARD]: "card-profile-apac-petrol-card",
            [CardProfileType.QR_CODE]: "card-profile-apac-qr-code",
        },
        eft4f: {
            [CardProfileType.ACTYS_PJE]: "card-profile-eft4f-actys-pje",
            [CardProfileType.AS24_CARD]: "card-profile-eft4f-as24-card",
            [CardProfileType.BANK_CARD]: "card-profile-eft4f-bank-card",
            [CardProfileType.BONUS_CARD]: "card-profile-eft4f-bonus-card",
            [CardProfileType.CODE_ENTRY]: "card-profile-eft4f-code-entry",
            [CardProfileType.EPAY_ETOP_UP]: "card-profile-eft4f-epay-etop-up",
            [CardProfileType.ETOP_UP]: "card-profile-eft4f-etop-up",
            [CardProfileType.GIFT_CARD]: "card-profile-eft4f-gift-card",
            [CardProfileType.LOYALTY_CARD]: "card-profile-eft4f-loyalty-card",
            [CardProfileType.PETROL_CARD]: "card-profile-eft4f-petrol-card",
            [CardProfileType.PETROL_EMV_CARD]: "card-profile-eft4f-petrol-emv-card",
            [CardProfileType.QR_CODE]: "card-profile-eft4f-qr-code",
            [CardProfileType.TOP_UP]: "card-profile-eft4f-top-up",
            [CardProfileType.PAGOBANCOMAT_CARD]: "card-profile-eft4f-pagobancomat-card",
        },
    },
};
